export const CONTACTS = [
    [
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1644160893/Logo/YIT_kegwop.png',
            title: 'Website Khoa Công nghệ Thông tin',
            url: 'http://fit.hcmute.edu.vn/',
        },
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1644160893/Logo/YIT_kegwop.png',
            title: 'Văn phòng điện tử Đoàn - Hội khoa Công nghệ Thông tin',
            url: 'https://youth-itute.vercel.app/',
        },
        {
            imgUrl: 'https://img.icons8.com/color/480/000000/facebook-new.png',
            title: 'Fanpage Đoàn - Hội Khoa Công Nghệ Thông Tin',
            url: 'https://www.facebook.com/DoanHoiITUTE',
        },
        {
            imgUrl: 'https://img.icons8.com/color/480/000000/facebook-new.png',
            title: 'Fanpage Khoa Công nghệ Thông tin',
            url: 'https://www.facebook.com/fit.hcmute.edu.vn',
        },
    ],
    [
        {
            imgUrl: 'https://img.icons8.com/color/480/000000/facebook-new.png',
            title: 'DIỄN ĐÀN SINH VIÊN CÔNG NGHỆ THÔNG TIN',
            url: 'https://www.facebook.com/groups/cnttspkt',
        },
        {
            imgUrl: 'https://img.icons8.com/color/480/000000/facebook-new.png',
            title: 'Group SINH VIÊN 5 TỐT-KHOA CÔNG NGHỆ THÔNG TIN',
            url: 'https://www.facebook.com/groups/itute.sv5t'
        },
        {
            imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1648317647/Logo/zalo_dznmst.svg',
            title: 'Group Zalo Hỗ trợ Sinh viên 5 tốt - Khoa Công nghệ Thông tin HCMUTE',
            url: 'https://zalo.me/g/ncaoht371',
        },
        {
            imgUrl: 'https://img.icons8.com/color/480/000000/discord-new-logo.png',
            title: 'Group Discord Sinh viên Khoa Công nghệ Thông tin',
            url: 'https://discord.com/invite/pVCX6tyMXX',
        },
    ],
    [
        {
            imgUrl: 'https://img.icons8.com/color/480/000000/youtube-play.png',
            title: 'Youtube Đoàn - Hội Khoa Công nghệ Thông tin',
            url: 'https://www.youtube.com/channel/UCGfDCrVFCmRTyQ5X8r0XZvw'
        },
        {
            imgUrl: 'https://img.icons8.com/ios-filled/96/tiktok--v1.png',
            title: 'Tiktok Đoàn - Hội Khoa Công nghệ Thông tin',
            url: 'https://www.tiktok.com/@yit_hcmute'
        },
        {
            imgUrl: 'https://img.icons8.com/fluency/96/github.png',
            title: 'Github Đoàn - Hội Khoa Công nghệ Thông tin',
            url: 'https://github.com/ITUTE'
        },
        {
            imgUrl: 'https://img.icons8.com/color/96/circled-envelope.png',
            title: 'Email Đoàn - Hội Khoa Công nghệ Thông tin',
            url: 'mailto:yit@hcmute.edu.vn'
        },
    ]
]